import { copyToClipboard } from "@suse-o11y/copy-to-clipboard";
import { Dialog, DialogClose, DialogTitle } from "@suse-o11y/dialog";
import { IconClose } from "@suse-o11y/icons";
import type { JSON } from "@suse-o11y/json";
import React from "react";

import { Editor } from "~/components/code/editor";

import { DONT_AUTO_DISMISS, notification } from "../../../../components/react/notification/Notification";
import { jsonToYaml } from "../../../../generic/yamlUtils";

interface YamlDisplayDrawerProps {
	title: React.ReactNode;
	source: JSON;
}

export const YamlDisplayDrawer: React.FC<YamlDisplayDrawerProps> = (props) => (
	<Dialog className="drawer-wide drawer/dialog">
		<DrawerContent {...props} />
	</Dialog>
);

const DrawerContent: React.FC<YamlDisplayDrawerProps> = ({ title, source }) => {
	const yaml = React.useMemo(() => jsonToYaml(source), [source]);

	return (
		<>
			<header className="drawer-header">
				<DialogTitle className="drawer-title">{title}</DialogTitle>

				<DialogClose aria-label="Close" className="button button-square ml-auto">
					<IconClose className="size-3" />
				</DialogClose>
			</header>

			<section className="drawer-body">
				<Editor height="100%" language="yaml" readOnly value={yaml} />
			</section>

			<footer className="drawer-footer">
				<DialogClose className="button button-tertiary uppercase">Close</DialogClose>

				<button
					className="button button-primary uppercase"
					onClick={() => {
						const [failure, success] = copyToClipboard(yaml, "YAML");

						if (failure == null) {
							notification.success({ message: success });
						} else {
							notification.error({
								message: failure,
								duration: DONT_AUTO_DISMISS,
							});
						}
					}}
					type="button"
				>
					Copy to clipboard
				</button>
			</footer>
		</>
	);
};
